import { useState, useEffect, useRef } from "react";
import "../../../../css/AML/Tooltip/AMLTooltip.css";
import { ReactComponent as TooltipIcon } from "../../../../assets/icons/info.svg";

const InfoTooltip = ({
  children,
  text,
  position = "left",
  icon = <TooltipIcon />,
}) => {
  const [open, setOpen] = useState(false);
  const [locked, setLocked] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setLocked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div
      className="TooltipContainer"
      ref={ref}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => {
        if (!locked) setOpen(false);
      }}
      onClick={(e) => {
        e.stopPropagation();
        setLocked((prev) => !prev); // toggle lock
        setOpen(true);
      }}
      role="button"
      aria-label=""
      tabIndex={0}
    >
      {/* If children passed → use it, else fallback to icon */}
      {children || <span className="DCCTooltipIcon">{icon}</span>}

      {open && (
        <div className={`TooltipBubble Info Tooltip-${position} dcc-top`}>
          <div className="AML-Text-Body">{text}</div>
          <span className={`TooltipArrow Info TooltipArrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
